import { createAction, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface ClaimCategoryPayload {
    policyTypeCode: string;
}

export interface GeneralResponse {
    data: ClaimCategory;
}

export interface ClaimCategory {
    id: string;
    code: string;
    name: string;
}
export interface ErrorResponse {
    errors: Array<string>;
}

// @ts-ignore
export const fetchClaimCategories = createAction<fetchClaimCategoriesAction>(
    ActionTypes.FETCH_CLAIM_CATEGORIES,
);
// @ts-ignore
export const fetchClaimCategoriesSuccess =
    createAction<fetchClaimCategoriesSuccessAction>(
        ActionTypes.FETCH_CLAIM_CATEGORIES_SUCCESS,
    );
// @ts-ignore
export const fetchClaimCategoriesFailed =
    createAction<fetchClaimCategoriesFailedAction>(
        ActionTypes.FETCH_CLAIM_CATEGORIES_FAILED,
    );
export const fetchClaimCategoriesByPolicyType =
    createAction<fetchClaimCategoriesByPolicyTypeAction>(
        ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE,
    );
export const fetchClaimCategoriesByPolicyTypeSuccess =
    createAction<fetchClaimCategoriesByPolicyTypeSuccessAction>(
        ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_SUCCESS,
    );
export const fetchClaimCategoriesByPolicyTypeFailed =
    createAction<fetchClaimCategoriesByPolicyTypeFailedAction>(
        ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_FAILED,
    );
export const clearClaimCategoryState = createAction<
    clearClaimCategoryStateAction | undefined
>(ActionTypes.CLEAR_CLAIM_CATEGORY_STATE);

export interface fetchClaimCategoriesAction {
    type: typeof ActionTypes.FETCH_CLAIM_CATEGORIES;
    payload: ClaimCategoryPayload;
}

export interface fetchClaimCategoriesSuccessAction {
    type: typeof ActionTypes.FETCH_CLAIM_CATEGORIES_SUCCESS;
    payload: GeneralResponse;
}

export interface fetchClaimCategoriesFailedAction {
    type: typeof ActionTypes.FETCH_CLAIM_CATEGORIES_FAILED;
    payload: GeneralResponse;
}

export interface fetchClaimCategoriesByPolicyTypeAction extends PayloadAction<any> {
    type: typeof ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE;
}

export interface fetchClaimCategoriesByPolicyTypeSuccessAction {
    type: typeof ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_SUCCESS;
    body: GeneralResponse;
}

export interface fetchClaimCategoriesByPolicyTypeFailedAction {
    type: typeof ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_FAILED;
    body: ErrorResponse;
}

export interface clearClaimCategoryStateAction {
    type?: typeof ActionTypes.CLEAR_CLAIM_CATEGORY_STATE;
}
